import checkProductSubscription from '@paywall/graphql/checkProductSubscription.graphql';
import errorLogger from '@paywall/utils/errorLogger';
import isServerError from '@paywall/utils/isServerError';
import { CheckProductSubscription } from '@paywall/types/checkProductSubscription';

import ServiceBase from '@ekd/portal-connector/dist/Service';
import { ApiUrls } from '@root/common/types/apiUrls';

export function createCheckAdFreeService({ service }: { service: ServiceBase<ApiUrls> }) {
  return {
    async checkAdFree(token: string | null) {
      if (!token) {
        return false;
      }

      try {
        // Check if user has adFree package
        const apiProvider = service.createProvider('GraphQL');
        apiProvider.selectAPI('paywall-api');
        // Check if user has adFree package
        const data = await apiProvider.request<CheckProductSubscription['data']>({
          query: checkProductSubscription,
          variables: {
            products: ['afd'],
          },
          context: {
            headers: { Authorization: `Bearer ${token}` },
          },
        });

        return data.results[0].access;
      } catch (error) {
        // Handle API 500 errors
        if (isServerError(error)) {
          errorLogger({ name: 'checkProductSubscription() - server error', message: error });
          return true;
        }
        errorLogger({ name: 'checkProductSubscription()', message: error });
        return false;
      }
    },
  };
}
